import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase 
} from "@models";
import { 
  RollOption,
  RollableTable,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import RollOptions from "@dndComponents/other/RollOptions";
import StringBox from "@components/input/strings/StringBox";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  rollable_table_id: string;
  onChange: (changed: RollableTable) => void; 
  onCancel?: () => void; 
  disabled?: boolean;
  height?: number;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function RollableTableInput({ 
  rollable_table_id,
  onChange, 
  onCancel, 
  // disabled = false,
  height = 220
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState(new RollableTable());
  const [change_time, setChangeTime] = useState(-1);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  const load = () => {
    setLoading(true);
    setFetched(true);
    api.getObjects({data_type: "rollable_table"}).then(res => {
      const id = rollable_table_id;
      const new_rollable_tables = res as RollableTable[];
      if (id !== "New" && obj._id !== id) {
        const new_obj = new_rollable_tables.find(o => o._id === id);
        if (new_obj) {
          setObj(new_obj);
        }
      } else {
        if (api.user && !api.user.admin && obj.name === "" && obj.owner_id === "") {
          const new_obj = obj;
          new_obj.owner_id = api.user._id;
          setObj(new_obj);
        }
      }
      // setRollableTables(new_rollable_tables);
      setLoading(false);
    });
  }

  // const submit = () => {
  //   setProcessing(true);
  //   api.upsertObject("rollable_table", obj).then(res => {
  //     onChange(obj);
  //     setProcessing(false);
  //   });
  // }

  if (!fetched || loading) {
    return <LoadingBox />;
  } else {
    const disabled = api.user === null || !api.online || (!api.user.admin && obj.owner_id !== api.user._id);
    
    return (
      <ModelBaseInput 
        obj={obj}
        disabled={disabled}
        onChange={(changed: ModelBase) => {
          if (changed instanceof RollableTable) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
          }
        }}
        onSubmit={(changed: ModelBase) => {
          if (changed instanceof RollableTable) {
            api.upsertObject("rollable_table", obj).then(res => {
              onChange(obj);
            });
          }
        }}
        onCancel={onCancel}>
        <Grid container spacing={0} direction="row">
          <Grid size={12}>
            <StringBox 
              name="Dice Size"
              value={obj.dice_size}
              onChange={(value: string) => {
                const new_obj = obj;
                new_obj.dice_size = +value;
                setObj(new_obj);
              }}
            />
          </Grid>
          <Grid size={12}>
            <RollOptions 
              roll_options={obj.roll_options}
              change_time={change_time}
              onChange={(changed: RollOption[]) => {
                const new_obj = obj;
                new_obj.roll_options = changed.map(o => { return {...o}; });
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        </Grid>
      </ModelBaseInput>
    );
  }
}